const tblSingle = {
  55: [30.4,33,36.8,43.6],
  56: [31.4,34,37.6,44.9],
  57: [32.4,35,38.8,46],
  58: [33.9,36,39.8,47.2],
  59: [34.9,36.8,41,48.5],
  60: [36.9,37.6,41.9,49.5],
  61: [37.9,38.8,43,50.3],
  62: [38.9,39.8,43.6,51.5],
  63: [39.9,41,44.9,52.4],
  64: [40.9,41.9,46,53.5],
  65: [41.9,43,47.2,54.4],
  66: [43,43.6,48.5,54.5],
  67: [44,44.9,49.5,54.5],
  68: [45,46,50.3,54.5],
  69: [46,47.2,51.5,54.5],
  70: [47,48.5,52.4,54.5],
  71: [47.6,49.5,53.5,54.5],
  72: [48.6,50.3,54.4,54.5],
  73: [49.6,51.5,54.5,54.5],
  74: [50.6,52.4,54.5,54.5],
  75: [51.7,53.5,54.5,54.5],
  76: [52.7,54.4,54.5,54.5],
  77: [53.8,54.5,54.5,54.5],
  78: [54.8,54.5,54.5,54.5],
  79: [55.8,54.5,54.5,54.5],
  80: [57,54.5,54.5,54.5],
  81: [58,54.5,54.5,54.5],
  82: [58.24,54.5,54.5,54.5],
  83: [59.28,54.5,54.5,54.5],
  84: [59.28,54.5,54.5,54.5],
  85: [59.28,54.5,54.5,54.5],
  86: [59.28,54.5,54.5,54.5],
  87: [59.28,54.5,54.5,54.5],
  88: [59.28,54.5,54.5,54.5],
  89: [59.28,54.5,54.5,54.5],
  90: [59.28,54.5,54.5,54.5],
};

const tblJoint = {
  55: [30.4,33,36.8,43.6],
  56: [31.4,34,37.6,44.9],
  57: [32.4,35,38.8,46],
  58: [33.9,36,39.8,47.2],
  59: [34.9,36.8,41,48.5],
  60: [36.9,37.6,41.9,49.5],
  61: [37.9,38.8,43,50.3],
  62: [38.9,39.8,43.6,51.5],
  63: [39.9,41,44.9,52.4],
  64: [40.9,41.9,46,53.5],
  65: [41.9,43,47.2,54.4],
  66: [43,43.6,48.5,54.5],
  67: [44,44.9,49.5,54.5],
  68: [45,46,50.3,54.5],
  69: [46,47.2,51.5,54.5],
  70: [47,48.5,52.4,54.5],
  71: [47.6,49.5,53.5,54.5],
  72: [48.6,50.3,54.4,54.5],
  73: [49.6,51.5,54.5,54.5],
  74: [50.6,52.4,54.5,54.5],
  75: [51.7,53.5,54.5,54.5],
  76: [52.7,54.4,54.5,54.5],
  77: [53.8,54.5,54.5,54.5],
  78: [54.8,54.5,54.5,54.5],
  79: [55.8,54.5,54.5,54.5],
  80: [57,54.5,54.5,54.5],
  81: [58,54.5,54.5,54.5],
  82: [58.24,54.5,54.5,54.5],
  83: [59.28,54.5,54.5,54.5],
  84: [59.28,54.5,54.5,54.5],
  85: [59.28,54.5,54.5,54.5],
  86: [59.28,54.5,54.5,54.5],
  87: [59.28,54.5,54.5,54.5],
  88: [59.28,54.5,54.5,54.5],
  89: [59.28,54.5,54.5,54.5],
  90: [59.28,54.5,54.5,54.5],
};

// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 90) ? 90 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];
  const Healthy = parseInt( housePrice * 0.01 * tbl[0], 10);
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[2], 10);
  const Severe = parseInt( housePrice * 0.01 * tbl[3], 10);

  const result = { Healthy, Mild, Moderate, Severe };
  result.max = result[ ltvPlan || 'Severe' ];
  result.diff = result.Severe - result.Healthy;
  result.pct = { Healthy: tbl[0], Mild: tbl[1], Moderate: tbl[2], Severe: tbl[3] };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js